// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-provider-accounts .provider
{
	font-size: 17px;
	line-height: 20px;
	padding-top: 16px;
	padding-bottom: 16px;
	margin-left: 16px;
	margin-right: 16px;
	border-bottom: solid 1px #c7c7cb;
}

	.my-provider-accounts .provider:last-child
	{
		border-bottom: none;
	}

		.my-provider-accounts .provider .provider-name
		{
			font-weight: 600;
		}

	.my-provider-accounts .account-actions
	{
		float: right;
		margin-bottom: 16px;
	}

	.my-provider-accounts .account-status
	{
		font-size: 15px;
		margin-right: 16px;
		color: #aaa;
	}

		.my-provider-accounts .account-status.error
		{
			color: #df2410;
		}

	.my-provider-accounts .primary-btn
	{
		padding: 0 20px;
	}

	.my-provider-accounts .remove-account
	{
		color: #aaa !important;
	}

.my-provider-accounts .no-results
{
	font-size: 17px;
	padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/MyProviderAccounts.css"],"names":[],"mappings":"AAAA;;CAEC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;CAClB,gCAAgC;AACjC;;CAEC;;EAEC,mBAAmB;CACpB;;EAEC;;GAEC,gBAAgB;EACjB;;CAED;;EAEC,YAAY;EACZ,mBAAmB;CACpB;;CAEA;;EAEC,eAAe;EACf,kBAAkB;EAClB,WAAW;CACZ;;EAEC;;GAEC,cAAc;EACf;;CAED;;EAEC,eAAe;CAChB;;CAEA;;EAEC,sBAAsB;CACvB;;AAED;;CAEC,eAAe;CACf,aAAa;AACd","sourcesContent":[".my-provider-accounts .provider\n{\n\tfont-size: 17px;\n\tline-height: 20px;\n\tpadding-top: 16px;\n\tpadding-bottom: 16px;\n\tmargin-left: 16px;\n\tmargin-right: 16px;\n\tborder-bottom: solid 1px #c7c7cb;\n}\n\n\t.my-provider-accounts .provider:last-child\n\t{\n\t\tborder-bottom: none;\n\t}\n\n\t\t.my-provider-accounts .provider .provider-name\n\t\t{\n\t\t\tfont-weight: 600;\n\t\t}\n\n\t.my-provider-accounts .account-actions\n\t{\n\t\tfloat: right;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t.my-provider-accounts .account-status\n\t{\n\t\tfont-size: 15px;\n\t\tmargin-right: 16px;\n\t\tcolor: #aaa;\n\t}\n\n\t\t.my-provider-accounts .account-status.error\n\t\t{\n\t\t\tcolor: #df2410;\n\t\t}\n\n\t.my-provider-accounts .primary-btn\n\t{\n\t\tpadding: 0 20px;\n\t}\n\n\t.my-provider-accounts .remove-account\n\t{\n\t\tcolor: #aaa !important;\n\t}\n\n.my-provider-accounts .no-results\n{\n\tfont-size: 17px;\n\tpadding: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
